export default __webpack_public_path__ + "static/media/rocket_anim_110.236648bf.png";